<!--
 * @Descripttion: logisticsOrderList--物流订单表
 * @version: 1
 * @Author: lk
 * @Date: 2019-08-19 17:14:03
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-11 10:38:46
 -->
<template>
  <div v-loading.fullscreen="loading" element-loading-text="加载中">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="searchParam" @search="search" @reset="reset" />
    </el-card>
    <el-card>
      <el-table ref="dataTable" :height="heightStyleObj" :data="pageListData" highlight-current-row border>
        <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
          <template slot-scope="{ $index }">
            {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="materialName" min-width="120px" label="物料名称" />
        <el-table-column show-overflow-tooltip prop="specification" min-width="120px" label="物料规格型号">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="diCode" width="120px" label="产品DI">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="packLevel" width="120px" label="包装层级">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="materialCode" width="120px" label="物料编码" />
        <el-table-column show-overflow-tooltip prop="bizType" width="120px" label="单据类型">
          <template slot-scope="scope">
            <dict-tag :options="dictObj.receiptDeliveryBizType" :value="scope.row.bizType" />
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="bizCode" width="140px" label="单据编号" />
        <el-table-column show-overflow-tooltip prop="warehouseName" width="120px" label="仓库名称" />
        <el-table-column show-overflow-tooltip prop="batchNumber" min-width="120px" label="批号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="beginStorageNum" width="120px" label="期初数量" />
        <el-table-column show-overflow-tooltip prop="inNum" width="120px" label="收入数量"></el-table-column>
        <el-table-column show-overflow-tooltip prop="outNum" width="120px" label="发出数量"></el-table-column>
        <el-table-column show-overflow-tooltip prop="endStorageNum" width="120px" label="结存数"></el-table-column>
        <el-table-column show-overflow-tooltip width="150px" label="操作时间">
          <template slot-scope="{ row }">
            {{ row.createTime ? parseTime(row.createTime, '{y}-{m}-{d} {h}:{i}:{s}') : null }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="180" align="center">
          <template slot-scope="{ row }">
            <el-button v-if="$btnsPermission('receiptDelivery:ck')" type="text" @click="handlePreview(row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
        :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
    </el-card>
    <detialReceipt v-if="previewShow" :dict-obj="dictObj" :visible="previewShow" :inventory-info="inventoryInfo"
      @close="close">
    </detialReceipt>
  </div>
</template>

<script>
import { getDict } from '@/api/common'
import { getReciptDeliveryList } from '@/api/reciptDelivery'
import detialReceipt from './components/detialReceipt'
import { getWareHouse } from '../../api/warehouse'
export default {
  name: 'ReceiptDelivery',
  components: {
    detialReceipt,
  },
  data() {
    return {
      heightStyleObj: '',
      loading: true, // 遮罩
      previewShow: false,
      pageListData: [], // 列表数据
      queryItems: [
        {
          label: '关键字',
          field: 'searchValue',
          placeholder: '物料编码/物料名称/规格型号/DI码',
          width: '300px',
          type: 'input'
        },
        {
          label: '单据类型',
          field: 'bizType',
          type: 'select',
          options: []
        },
        {
          label: '仓库',
          field: 'warehouseId',
          type: 'select',
          options: []
        },
        {
          label: '批号',
          field: 'batchNumber',
          type: 'input'
        },
        {
          label: '单据编号',
          field: 'bizCode',
          type: 'input'
        },
        {
          label: '创建时间',
          field: 'dateTime',
          type: 'date',
        },
      ],

      searchParam: { // 查询参数
        pageNum: 1,
        pageSize: 10,
        total: 0,
        searchValue: null,
        bizCode: null,
        bizType: null
      },
      dictObj: {
        receiptDeliveryBizType: [],
        receiptDeliveryState: []
      },
    }
  },


  created() {
    this.heightStyleObj = window.innerHeight - 405 + 'px'
    this.getPageListData()
    this.getWareHouse()
    this.getDicts(['receiptDeliveryState', 'receiptDeliveryBizType'])

  },
  methods: {
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
          if (dictType === 'receiptDeliveryBizType') {
            const findIndex = this.queryItems.findIndex(item => item.field === 'bizType')
            this.queryItems[findIndex].options = JSON.parse(JSON.stringify(res.rows))
          }
        })
      })
    },
    // 获取入库仓库
    getWareHouse() {
      getWareHouse({pageSize:99999,pageNum:1}).then((res) => {
        this.queryItems[this.queryItems.findIndex(item => item.field === 'warehouseId')].options = res.rows.map(item => {
          return {
            dictValue: item.id,
            dictLabel: item.name
          }
        })
      })
    },
    handlePreview(row) {
      this.previewShow = true
      this.inventoryInfo = JSON.parse(JSON.stringify(row))
    },
    close() {
      this.previewShow = false
    },

    // 查询
    search() {
      this.searchParam.pageNum = 1
      this.getPageListData()
    },
    // 重置查询
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },

    // 获取列表数据
    getPageListData() {
      this.loading = true
      const searchParam = JSON.parse(JSON.stringify(this.searchParam))
      if (searchParam.dateTime) {
        const [startDate, endDate] = searchParam.dateTime
        searchParam.startDate = startDate
        searchParam.endDate = endDate
        delete searchParam.dateTime
      }
      getReciptDeliveryList(searchParam).then(res => {
        this.searchParam.total = res.total
        this.pageListData = res.rows
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>
